import React from 'react';
import footerLinks from '../collections/footerLinks.js'
export default class Footer extends React.Component {
    constructor(props) {
        super ( props );

        this.state = {};
        this.renderLinks = this.renderLinks.bind ( this );
        this.renderAllLinks = this.renderAllLinks.bind ( this );
    }

    renderLinks(linkSubset) {
        let links = footerLinks[linkSubset];
        let array = [<h4 key={linkSubset}>{linkSubset}</h4>];
        for (let link in links) {
            array.push ( <a key={links[link].name} href={links[link].url}>{links[link].name}</a> );
        }
        return array;
    }

    renderAllLinks() {
        let collection = footerLinks;
        let array= [];
        for (let set in collection) {
            array.push( <div key={set} className={"footer-links"}>{ this.renderLinks ( set )}</div>)
        }
        return array;
    }

    render() {
        return (
            <div className={"flex-center column"}>
                <div
                    className={"footer flex-between grow-1 w-100"}
                >
                    <div className={'banner-image'} style={{ borderRight : "1px solid black" }}>
                        <img src={require("../images/cards.jpg")} style={{ maxWidth : "100%" }} alt={"..."}/>
                    </div>
                    <div className={'banner-image'} style={{ borderRight : "1px solid black" }}>
                        <img src={require("../images/vreifiedcollage.png")} style={{ maxWidth : "100%" }} alt={"..."}/>
                    </div>
                    <div className={'banner-image'} style={{ borderRight : "1px solid black" }}>
                        <img src={require("../images/TelefonKontaktButton.jpg")} style={{ maxWidth : "100%" }} alt={"..."}/>
                    </div>
                    <div className={'banner-image'}>
                        <img src={require("../images/ea.jpg")} width={"100px"} alt={"..."}/>
                    </div>
                </div>
                <div className={"links-section grow-1 w-100"}>
                {this.renderAllLinks ()}
            </div>
            </div>
        );
    }
}